import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import {
  PineCancelPopUpEnum,
  PineLabsConsts,
  PineLabsEnum,
} from 'src/app/common/enums/pinelabs.enum';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { CROSS } from 'src/defaultImages.js';

@Component({
  selector: 'app-cancel-payment',
  templateUrl: './cancel-payment.component.html',
  styleUrls: ['./cancel-payment.component.css'],
})
export class CancelPaymentComponent implements OnInit {
  @Input() orderId: string;
  @Input() ptrId: string;
  @Input() pmtId: string;
  @Input() amount: number;
  images = {
    CROSS: CROSS,
  };
  isLoading: boolean = false;
  constructor(
    private _modalRef: NzModalRef,
    private _apiService: ApiService,
    private _messageService: MessageService
  ) {}
  ngOnInit() {}
  cancelClicked() {
    this.closeCancelPopUp(PineCancelPopUpEnum.CANCEL_CANCELLED, '');
  }
  cancelPayment() {
    if (!this.isLoading) {
      this.isLoading = true;
      const cancelPLPmtPayLoad = {
        order_id: this.orderId,
        ptr_id: this.ptrId,
        transaction_number: this.pmtId,
        amount: this.amount,
      };
      this._apiService.cancelPLPayment(cancelPLPmtPayLoad).subscribe(
        (res) => {
          this.isLoading = false;
          if (res.data && res.data.ResponseCode == PineLabsConsts.SUCCESS) {
            this.closeCancelPopUp(
              PineCancelPopUpEnum.CANCEL_SUCCESS,
              PineLabsEnum.PAYMENT_CANCELLED
            );
          } else {
            this.closeCancelPopUp(PineCancelPopUpEnum.CANCEL_REJECTED, '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.closeCancelPopUp(PineCancelPopUpEnum.CANCEL_REJECTED, '');
        }
      );
    }
  }
  closeCancelPopUp(status: number, message: string): any {
    this._modalRef.close({
      status: status,
      message: message,
    });
  }
}
